module.exports = __webpack_public_path__ + "img/notification-fill.3a953e0b.svg";